<template>
  <div>
    <job-preview-comments
      v-show="highlightMode"
      v-if="commentHighlights.length"
      :class="commentClass"
      :comments="commentHighlights"
      v-on="$listeners"
    />
    <div
      v-if="textCountMode && textCountsNotNull.length"
      class="pega-text-count-area"
      :class="textCountClass"
      data-test="text-count-area"
    >
      <text-count
        v-for="textCount in textCountsNotNull"
        :key="textCount.name"
        :name="textCount.name"
        :count-target="textCount.value"
        :max="textCount.max"
        :tooltip="textCount.tooltip"
        :margin="textCount.margin"
      />
    </div>
  </div>
</template>

<script>
import JobPreviewComments from '@/components/molecules/JobPreviewComments'
import TextCount from '@/components/atoms/TextCount'

export default {
  components: {
    JobPreviewComments,
    TextCount
  },
  props: {
    highlightMode: {
      type: Boolean,
      required: true
    },
    commentClass: {
      type: String,
      default: ''
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    textCountMode: {
      type: Boolean,
      required: true
    },
    textCountClass: {
      type: String,
      default: ''
    },
    textCounts: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    textCountsNotNull () {
      return this.textCounts.filter(textCount => textCount.value)
    }
  }
}
</script>
